const ENV = 4;      // 环境标识 1: 本地环境, 2: 测试环境, 3: 蜗趣记账-正式环境, 4: 莫扎特-正式环境    默认为本地环境

export const API_CONFIG = {
  baseURL: (ENV === 1) ? 'http://localhost:8086'            // 本地环境
         : (ENV === 2) ? '//open-fos.linyaoyan.top'         // 测试环境
         : (ENV === 3) ? '//fos.linyaoyan.top'             // 蜗趣记账-正式环境
         : (ENV === 4) ? '//fos.mozart2014.top' : 'NO-ENV',  // 莫扎特-正式环境
  timeout: 10000
}

export const API_PATHS = {
  register: '/fos/platform/user/register',
  validate: '/fos/platform/validate',
  login: '/fos/platform/user/login',
  logout: '/fos/platform/user/logout',
  editUser: '/fos/platform/user/edit',
  generateAccessKey: '/fos/platform/access_key/generate',
  accessKey: '/fos/platform/access_key',
  setObjectKey: '/fos/platform/object_key/set',
  objectKey: '/fos/platform/object_key',
  tmpKeyList: '/fos/platform/tmp_key/list',
  generateTmpKey: '/fos/platform/tmp_key/generate',
  deleteTmpKey: '/fos/platform/tmp_key/delete',
  expireTmpKey: '/fos/platform/tmp_key/expire/set',
  operationList: '/fos/platform/operation/list',
  operationRecordList: '/fos/platform/operation/record/list',
  recharge: '/fos/platform/recharge/data',
  rechargeList: '/fos/platform/operation/recharge/list',
  CLIENT: {
    accessKey: '/fos/client/access_key',
    // 可以继续添加其他客户端请求路径
    fileUpload: '/fos/file/upload',
    fileDownload: '/fos/file/download',
    filePath: '/fos/file/path',
    fileList: '/fos/file/list',
    fileDelete: '/fos/file/delete'
  }
}

// 根据选择的请求类型生成请求地址
export const getApiUrl = (requestType) => {
  const clientPaths = API_PATHS.CLIENT;
  if (clientPaths[requestType]) {
    return `${clientPaths[requestType]}`;
  }
  throw new Error(`未找到请求类型 ${requestType} 对应的路径`);
}